<template>
    <div>
        <div class="comment" v-if="item" @click="clickpop(item)">
             <div class="comment-header">
                <div class="comment-header-pic"  @click.stop="gotomy(item)">
                    <img :src="$baseurl+item.headImg">
                </div>
                <div class="comment-header-wz">
                    <div class="comment-header-wz-tit">{{item.nick}}</div>
                    <div class="comment-header-wz-stit" v-if="item.signature">{{item.signature}}</div>
                    <div class="comment-header-wz-stit" v-if="!item.signature">未设置</div>
                </div>
                <div class="comment-right" @click.stop="like(item)">
                    <van-icon class="comment-right-icon" :size="18" v-if="!item.isLike"   name="like-o" />
                    <van-icon class="comment-right-icon" :size="18" v-if="item.isLike" color="red"   name="like" />
                    <span style="margin-left:5px;vertical-align:4px;font-size:14px;" v-if="item.giveLikeCount">{{item.giveLikeCount}}</span>
                </div>
            </div>
            <div class="comment-wz" >
                <div class="comment-wz-mian van-multi-ellipsis--l3">
                    {{item.content}}
                </div>
                <div class="comment-fwzs" v-if="item.replyList&&item.replyList.length>0">
                    <div v-for="(vitem,index) in item.replyList" :key="index">
                        <div class="comment-fwz van-multi-ellipsis--l3" @click.stop="clickpop(vitem)" v-if="!vitem.replyDealerId">
                            <span class="comment-fwz-color">{{vitem.nick}}：</span>
                            <span class="comment-fwz-mr">{{vitem.content}}</span>
                        </div>
                        <div class="comment-fwz van-multi-ellipsis--l3" @click.stop="clickpop(vitem)" v-if="vitem.replyDealerId">
                            <span class="comment-fwz-color">{{vitem.nick}}</span>
                            回复
                            <span class="comment-fwz-color">{{vitem.replyNick}}：</span>
                            <span class="comment-fwz-mr">{{vitem.content}}</span>
                        </div>
                    </div>
                    <div class="totalshow" @click.stop="godetail()" v-if="item.isThree&&item.replyCount">
                        <span>共{{item.replyCount}}条</span>
                         <van-icon
                            :size="13"
                            class-prefix="abc-icon"
                            name="you"
                        />
                    </div>
                </div>
            </div>     
        </div>

        <van-popup v-model="popshow" round close-on-popstate close-on-click-overlay>
            <div class="operas">
                <div class="opera operas-tit">
                    操作
                </div>
                <div class="opera" @click="reply()">
                    回复
                </div>
                <div class="opera" v-if="checkitem" v-clipboard:copy="checkitem.content" v-clipboard:success="onCopy" v-clipboard:error="onError">
                    复制该评论
                </div>
                <div class="opera" @click="cancel()">
                    取消
                </div>
            </div>
        </van-popup>
        
    </div>
</template>
<script>
import longpreepop from '@/components/common/longpreepop.vue';
import commenthead from '@/components/common/heads/commenthead.vue';
export default {
    components:{
        longpreepop,
        commenthead
    },
    name:'comment',
    props:{
        item:{
            type:Object,
            default:undefined,
        },
        vindex:{
            type:Number,
            default:0
        }
    },
    data(){
        return {
            popshow:false,
            checkitem:undefined,
            url1:'/commentlist',
            url2:'/addcomment'
        }
    },
    created(){
        //拉去前3条回复
       
        if(this.vindex==1)
        {
            this.url1="/recommentlist";
            this.url2="/addrecomment";
        }
    },
    methods:{
        // longpress(){
        //     this.popshow=true;
        // },
        onCopy(value)
        {
            this.$toast("复制成功");
            this.cancel();
        },
        onError(e)
        {
            this.$toast("复制失败,原因:"+e);
            this.cancel();
        },
        godetail(){
            var itemjson=JSON.stringify(this.item);
            this.$router.push({path:this.url1,query:{item:itemjson}});
        },
        reply(){
            var itemjson=JSON.stringify(this.checkitem);
            this.$router.push({path:this.url2,query:{item:itemjson}})
        },
        cancel()
        {
            this.popshow=false;
        },
        clickpop(item)
        {
            this.checkitem=item;
            this.popshow=true;
            // this.$toast("触发点击事件");
        },
        like(item)
        {
            this.$emit('like',item);
        }
    }
}
</script>
<style lang="scss" scoped>
.comment{
   padding: 10px 0;
   border-bottom:1px solid #ededed;
}
.comment:last-child{
    border: 0;
}

.comment-header{
        padding-left:50px;
        padding-right:30px;
        position: relative;
        min-height: 45px;
        line-height: 23px;
    }
    .comment-header-pic{
        position: absolute;
        left:0;
        width: 40px;
        height: 40px;
    }
    .comment-header-pic img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
    .comment-right{
        position: absolute;
        right:0;
        top:0;
    }
    .comment-header-wz-tit{
        font-size: 14px;
    }
    .comment-header-wz-stit{
        font-size: 12px;
        color:#a8a8a8;
    }


.comment-wz{
    padding-left:50px;
    font-size: 13px;
    word-break: break-all;
    line-height: 20px;
}
.comment-wz-mian{
    margin-bottom: 5px;
}
.comment-fwzs{
    background-color:#f8f8f8;
    padding: 10px;
    font-size: 13px;
}
.comment-fwz-color{
    color:#8085a5;
}

.totalshow{
    color:#797979;
    font-size: 12px;
    margin-top:2px;
}

.operas{
    background-color: #fff;
    font-size: 15px;
    width: 280px;
    border-radius: 30px;
}
.operas-tit{
    font-size: 17px;
    font-weight: bold;
}
.opera{
    padding: 14px;
    border-bottom: 1px solid #ededed;
}
.opera:last-child{
    border-bottom:0;
}

</style>